import {map, sortBy, toUpper} from 'lodash';
import moment from 'moment';
import {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {Icon, InformationModal, ShadowView} from 'components';
import {DateFormat, TimeFormat} from 'enums';
import {TRANSLATION_KEYS} from 'locale';
import {ClientConnect, ClientConnectNotificationType} from 'types';
import {dateUtils} from 'utils';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.CLIENTS_CONNECTIONS.SCHEDULED_MESSAGE_DETAILS_DIALOG;
const SEND_DIALOG_T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.CLIENTS_CONNECTIONS.SEND_MESSAGE_DIALOG;

type Props = {
    connect?: ClientConnect;
    timeZone: string;
    dateFormat: DateFormat;
    timeFormat: TimeFormat;
    open: boolean;
    onDelete: (connectId: string, messageId: string) => void;
    onClose: () => void;
};

export const ClientConnectScheduledMessagesDialog: React.FC<Props> = ({
    connect, timeZone, dateFormat, timeFormat, open, onDelete, onClose
}: Props) => {
    const {t} = useTranslation();
    const dateTimeFormat = useMemo(() => dateUtils.getDateTimeFormat(dateFormat, timeFormat), [dateFormat, timeFormat]);

    return (
        <InformationModal
            title={t(T_KEYS.TITLE)}
            maxWidth='sm'
            fullWidth
            open={open}
            onClose={onClose}
        >
            {map(sortBy(connect?.scheduledMessages, 'date'), (message) => (
                <div key={message.id} className='tw-flex tw-items-start tw-justify-between tw-mb-5 last:tw-mb-0 tw-w-full'>
                    <div className='tw-w-full'>
                        <div className='tw-flex tw-items-center tw-mb-1'>
                            <Icon name='calendar' className='tw-mr-1' />
                            <div className='tw-flex-1 tw-break-all'>
                                {moment.tz(message?.date, timeZone).format(dateTimeFormat)}
                                {` (${t(SEND_DIALOG_T_KEYS.NOTIFICATION_TYPE[toUpper(message.notificationType)])})`}
                            </div>
                            <Icon
                                button
                                name='delete'
                                color='alert'
                                className='tw-flex-shrink-0'
                                onClick={() => onDelete(connect.id, message.id)}
                            />
                        </div>
                        <div className='tw-flex tw-mb-1 tw-mt-2 -sm:tw-flex-col tw-max-w-104'>
                            {(message.notificationType === ClientConnectNotificationType.SMS ||
                            message.notificationType === ClientConnectNotificationType.Whatsapp) &&
                                <div className='tw-flex-1 tw-break-word'>
                                    {message?.content}
                                </div>}
                            {message.notificationType === ClientConnectNotificationType.Email &&
                                <ShadowView className='tw-overflow-auto'>
                                    <div className='tw-flex-1' dangerouslySetInnerHTML={{__html: message?.content}} />
                                </ShadowView>}
                        </div>
                    </div>
                </div>
            ))}
        </InformationModal>
    );
};
